__webpack_require__.p = "/workspace-configs-cleanup/referrals-hub/";